import { Heading4, Table, TextM, TextS } from 'app/components';
import {
  TableBodyCellContainer,
  TableHeadCellContainer,
} from 'app/styles/components/Table';
import { formatCurrency } from 'app/utils/normalizer';
import { formatDateFromBackend } from 'app/helpers/dateHelpers';
import { getBilletNumber } from 'modules/products/helpers/billets';
import { BilletsInfo } from 'modules/products/interfaces/billets';
import Accordion from 'app/components/Accordion/Accordion';
import { ReviewStepBox } from '../../styles';

interface ReviewStepBilletsAccordionProps {
  successBillets: BilletsInfo[];
  billetValidationResponse: {
    total_value?: number;
  } | null;
  isOpen: boolean;
  onClick: () => void;
}

const ReviewStepBilletsAccordion = ({
  successBillets,
  billetValidationResponse,
  isOpen,
  onClick,
}: ReviewStepBilletsAccordionProps) => {
  if (successBillets.length === 0) {
    return null;
  }

  return (
    <ReviewStepBox marginTop="16px" marginBottom="16px" padding="24px 8px">
      <Accordion
        cleanStyle={true}
        isOpen={isOpen}
        title={<Heading4>Boletos</Heading4>}
        onClick={onClick}
      >
        <Table
          tableHeadCell={[
            '',
            'Nº do documento',
            'Nome do sacado',
            'CPF / CNPJ',
            'Vencimento',
            'Valor',
          ].map((header, index) => ({
            id: String(index),
            content: (
              <TableHeadCellContainer>
                <TextS
                  weight="Bold"
                  style={{ marginLeft: index >= 2 ? '12px' : '0px' }}
                >
                  {header}
                </TextS>
              </TableHeadCellContainer>
            ),
          }))}
          tableBodyContent={successBillets.map((billet, inx) => {
            return {
              id: '1',
              cells: [
                {
                  id: '1',
                  content: (
                    <TableBodyCellContainer>
                      <TextS weight="Bold">{inx + 1}</TextS>
                    </TableBodyCellContainer>
                  ),
                },
                {
                  id: '2',
                  content: (
                    <TableBodyCellContainer>
                      <TextS
                        style={{
                          overflow: 'hidden',
                          display: 'inline-block',
                          whiteSpace: 'nowrap',
                          maxWidth: '150px',
                          marginTop: '5px',
                          textOverflow: 'ellipsis',
                        }}
                        weight="Regular"
                      >
                        {getBilletNumber(billet.request)}
                      </TextS>
                    </TableBodyCellContainer>
                  ),
                },
                {
                  id: '3',
                  content: (
                    <TableBodyCellContainer
                      style={{
                        overflow: 'hidden',
                        whiteSpace: 'break-spaces',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      <TextS style={{ width: 'fit-content' }} weight="Regular">
                        {billet.result.payer}
                      </TextS>
                    </TableBodyCellContainer>
                  ),
                },
                {
                  id: '4',
                  content: (
                    <TableBodyCellContainer
                      style={{
                        overflow: 'hidden',
                        whiteSpace: 'break-spaces',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      <TextS style={{ width: 'fit-content' }} weight="Regular">
                        {billet.result.document_payer}
                      </TextS>
                    </TableBodyCellContainer>
                  ),
                },
                {
                  id: '5',
                  content: (
                    <TableBodyCellContainer
                      style={{
                        overflow: 'hidden',
                        whiteSpace: 'break-spaces',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      <TextS style={{ width: 'fit-content' }} weight="Regular">
                        {billet.result.due_date
                          ? formatDateFromBackend(
                              billet.result.due_date,
                            ).toLocaleDateString('pt-BR')
                          : '-'}
                      </TextS>
                    </TableBodyCellContainer>
                  ),
                },
                {
                  id: '6',
                  content: (
                    <TableBodyCellContainer
                      style={{
                        overflow: 'hidden',
                        whiteSpace: 'break-spaces',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      <TextS style={{ width: 'fit-content' }} weight="Regular">
                        {formatCurrency(billet.result.amount)}
                      </TextS>
                    </TableBodyCellContainer>
                  ),
                },
              ],
            };
          })}
          tableFooterCell={[
            {
              id: '1',
              content: null,
            },
            {
              id: '2',
              content: null,
            },
            {
              id: '3',
              content: null,
            },
            {
              id: '4',
              content: null,
            },
            {
              id: '5',
              content: null,
            },
            {
              id: '6',
              content: (
                <TableBodyCellContainer>
                  <div style={{ display: 'block' }}>
                    <div>
                      <TextM>{`Valor Total:`}</TextM>
                    </div>
                    <div>
                      <TextM weight="Bold">
                        {formatCurrency(
                          billetValidationResponse?.total_value ?? 0,
                        )}
                      </TextM>
                    </div>
                  </div>
                </TableBodyCellContainer>
              ),
            },
            {
              id: '7',
              content: null,
            },
          ]}
        />
      </Accordion>
    </ReviewStepBox>
  );
};

export default ReviewStepBilletsAccordion;
